import { memo } from 'react';
import { cn } from '../../lib/styles';

interface VerticalDividerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const VerticalDividerBase = ({ className, ...rest }: VerticalDividerProps) => {
  return <div className={cn('h-5 w-px bg-gray-8', className)} {...rest} />;
};

export const VerticalDivider = memo(VerticalDividerBase);
